import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import AddCreditCardPage from './AddCreditCardPage';

export const prefix = 'bm-p-add-credit-card';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: AddCreditCardPage,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
